export default __webpack_public_path__ + "static/media/like-off.0a53b79e.svg";